module.exports = "./img/39cf29a39f1920fa0a4aefc7715435f3.jpg";